import * as React from "react"

import { getClient } from '../../../api/graphql'
import { ApolloProvider } from "react-apollo";
import { About, AboutRoutes } from "../../pages/About";
import { User } from "../../../types/types";
import { PageLoader } from "../../shared/loaders/PageLoader";
import * as Routes from "../../../api/routes";
import { query, variables, AboutQuery } from "../../../api/queries/about";

type Props = {
  current_user: User
}

export default (props: Props) : JSX.Element => (
  <ApolloProvider client={getClient()}>
    <AboutQuery
      query={query()}
      variables={variables()}
    >
      {({ loading, error, data}) => {
        if(loading) return <PageLoader />
        if(error) return <div>Something went wrong</div>
        return (
          <About
            current_user={props.current_user}
            routes={Routes.ToDictionary<AboutRoutes>(data.routes)}
            employees={data.employees.nodes}
          />
        )
      }}
    </AboutQuery>
  </ApolloProvider>
)
